import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const CtaSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$ctaSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$ctaSection' });

  const slides = [
    {
      id: 1,
      title: t('firstSlideTitle'),
      altTitle: t('firstSlideAltTitle'),
      imageSrc: 'images/homePage/ctaSection/luxury-collection-bedding.jpg',
      link: tLink('bedding'),
    },
    {
      id: 2,
      title: t('secondSlideTitle'),
      altTitle: t('secondSlideAltTitle'),
      imageSrc: 'images/homePage/ctaSection/luxury-collection-sheets.jpg',
      link: tLink('linens'),
    },
    {
      id: 3,
      title: t('thirdSlideTitle'),
      altTitle: t('thirdSlideAltTitle'),
      imageSrc: 'images/homePage/ctaSection/luxury-collection-bath-spa.jpg',
      link: tLink('bathandspa'),
    },
  ];

  const renderStaticSlides = (staticSlides: any[]): ReactElement => (
    <>
      {staticSlides.map(slide => (
        <div
          key={slide.id}
          className="card"
          data-event-name="bloc_interact"
          data-bloc-name={slide.title}
        >
          <Link href={slide.link} noTabbing>
            <div className="card-title-wrapper">
              <h3>
                <span>{slide.title}</span>
              </h3>
            </div>
            <div className="image-container">
              <img
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                data-src={slide.imageSrc}
                alt={slide.altTitle}
                src={slide.imageSrc}
                width="436"
                height="436"
              />
            </div>
          </Link>
        </div>
      ))}
    </>
  );

  return (
    <section id="hp-cta" className="hp-section cta-section">
      <div className="desktop-only">
        <div className="card-wrapper">{renderStaticSlides(slides)}</div>
      </div>
    </section>
  );
};

export default CtaSection;
